// export const encryptText = async (publicKey: string, inputText: string): Promise<string> => {
//   const keyBuffer = Uint8Array.from(atob(publicKey), c => c.charCodeAt(0));
//   const importedKey = await window.crypto.subtle.importKey(
//     "spki",
//     keyBuffer,
//     { name: "RSA-OAEP", hash: "SHA-256" },
//     false,
//     ["encrypt"]
//   );

//   const encodedText = new TextEncoder().encode(inputText);
//   const encrypted = await window.crypto.subtle.encrypt({ name: "RSA-OAEP" }, importedKey, encodedText);
//   return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
// };


export const encryptText = async (publicKey: string, inputText: string) => {
    const keyBuffer = Uint8Array.from(atob(publicKey), c => c.charCodeAt(0));
    const importedKey = await window.crypto.subtle.importKey(
      "spki",
      keyBuffer,
      { name: "RSA-OAEP", hash: "SHA-1" }, // Ensure SHA-1 for MGF1
      false,
      ["encrypt"]
    );

    const encodedText = new TextEncoder().encode(inputText);
    const encrypted = await window.crypto.subtle.encrypt({ name: "RSA-OAEP" }, importedKey, encodedText);
    
    // Convert Uint8Array to Base64
    return (btoa(String.fromCharCode(...new Uint8Array(encrypted))));
};

export const decryptText = async (privateKey: string, encryptedText: string): Promise<string> => {
  const keyBuffer = Uint8Array.from(atob(privateKey), c => c.charCodeAt(0));
  const importedKey = await window.crypto.subtle.importKey(
    "pkcs8",
    keyBuffer,
    { name: "RSA-OAEP", hash: "SHA-256" },
    false,
    ["decrypt"]
  );
  const encryptedBuffer = Uint8Array.from(atob(encryptedText), c => c.charCodeAt(0));
  const decrypted = await window.crypto.subtle.decrypt({ name: "RSA-OAEP" }, importedKey, encryptedBuffer);
  return new TextDecoder().decode(decrypted);
};
